import { connect } from 'react-redux'
import { checkQingJiafile } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkQingJiafile
}
const mapStateToProps = (state) => {
  return {
    ...state.QingJiaFileCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
